<template>
  <a
    class="carousel_item"
    :href="`${banner.url}${banner.anchor}`"
    :target="banner.action"
    @click="$emit('click', banner)">
    <img :src="banner.img" :alt="banner.alt" class="carousel_item_image" />
    <ul class="carousel_item_stage">
      <li v-for="(text, textIndex) in banner.content" :key="textIndex" class="carousel_item_stage_list">
        {{ text }}
      </li>
    </ul>
  </a>
</template>

<script>
const props = {
  banner: Object,
  index: Number,
};
export default {
  name: 'centerSliderItem',
  props,
};
</script>
